import { createContext } from 'react'


export const  PaymentContext = createContext(null)
